/**
 *
 * CollaboratorsTable
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
import { Table, Spin } from "antd"
import { filter, orderBy, map, uniqBy, slice, pick, isEqual } from "lodash"
import { columns } from "./colums"

import ModalCustom from "../ModalCustom"
import TeamModal from "../TeamModal"
import ModalSelectLeader from "../ModalSelectLeader"

import alertSvg from "../../images/alert.svg"
import "./index.less"
import {
  KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER,
  LOCAL_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
  LOCAL_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER,
  LOCAL_ORGANIZATION_COLLABORATORS_LEADERS_FILTER,
  setItem,
  LOCAL_VISMA_PEOPLE_SYNC_ENABLED,
} from "../../utils/storage"
import SegmentsModal from "./SegmentsModal"

class CollaboratorsTable extends React.Component {
  constructor(props) {
    super(props)
    // Referencias para limpiar timeouts
    this.timeouts = []
  }
  
  state = {
    stateCollaborators: [],
    gender: "",
    modalSelectLeader: false,
    modalTeam: false,
    collaboratorSelected: {},
    leaders: [],
    leadersSelected: JSON.parse(
      LOCAL_ORGANIZATION_COLLABORATORS_LEADERS_FILTER()
    ),
    hasMoreLeaders: true,
    divisions: [],
    divisionsSelected: JSON.parse(
      LOCAL_ORGANIZATION_COLLABORATORS_DIVISION_FILTER()
    ),
    segments: [],
    segmentsSelected: JSON.parse(
      LOCAL_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER()
    ),
    inputSearchLeader: "",
    inputSearchDivision: "",
    itsOkLeader: false,
    itsOkDivision: false,
    itsOkSegment: false,
    collaboratorsSelected: [],
    isLoadingState: true,
    showSegmentsModal: false,
    segmentsForModal: [],
    collaboratorNameForModal: "",
    tagFilters: [],
    paginationRecord: {
      current: 1,
      pageSize: 15,
      sortField: '',
      sortOrder: '',
    },
    leaderDropdownOpen: false,
    divisionDropdownOpen: false,
    segmentDropdownOpen: false,
  }

  componentDidMount = () => {
    // setear this.props.divisions en el state una sola vez
    if(this.props.divisions.length > 0 && this.state.divisions.length === 0) {
      this.setState({ leaders: this.props.leaders })
      this.setState({ divisions: this.props.divisions })
    }
    setItem(KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER, JSON.stringify([]))
    this.setState({
      divisionsSelected: [],
      segmentsSelected: [],
      leadersSelected: [],
      isLoadingState: false,
    })
    window.addEventListener("resize", this.updateTableResize)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateTableResize)
    // Limpiar todos los timeouts para evitar memory leaks
    this.timeouts.forEach(timeout => clearTimeout(timeout))
    this.timeouts = []
  }

  // Función helper para manejar timeouts de manera segura
  setSafeTimeout = (callback, delay) => {
    const timeout = setTimeout(callback, delay)
    this.timeouts.push(timeout)
    setItem(KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER, JSON.stringify([]))
    return timeout
  }

  updateTableResize = () => {
    this.forceUpdate()
  }

  loadFilterFromStorage = () => {
    this.setSafeTimeout(() => {
      if (this.state.divisionsSelected) {
        this.filterForDivisionOk()
      }
      // se elimina el filtro de líderes
      /* if (this.state.leadersSelected) {
        this.filterForLeaderOk()
      } */
      if (this.state.segmentsSelected) {
        this.filterForSegmentsOk()
      }

      this.setState({ isLoadingState: false, leadersSelected: [] })
      // Update tag filters after loading from storage
      this.setSafeTimeout(() => this.updateTagFilters(), 100)
    }, 0)
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.collaborators.length !== prevState.stateCollaborators.length
    ) {
      if (prevProps.collaborators.length !== this.props.collaborators.length) {
        this.setState({
          stateCollaborators: this.props.collaborators,
          leaders: slice(
            orderBy(
              uniqBy(this.props.leaders, "employee_parent_name"),
              "employee_parent_name"
            ),
            0,
            100
          ),
          divisions: uniqBy(this.props.divisions, "division_name"),
          segments:  this.props.segments,
        }, () => {
          // Update tag filters when data changes
          this.setSafeTimeout(() => this.updateTagFilters(), 100)
        })
      }
    }
    if (document.querySelector(".ant-spin-nested-loading")) {
      // Fix scroll
      document.querySelector(
        ".ant-spin-nested-loading"
      ).style.width = `${window.innerWidth - 72}px`
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.collaborators, this.props.collaborators)) {
      // usamos el set time out para cargar los filtros pre-guardados
    //  this.loadFilterFromStorage()
    } else if (this.state.isLoadingState) {
      this.setState({ isLoadingState: false })
    }
  }

  addItemsUpdateToDropdown = (name) => {
    if (name === "leaders") {
      return this.setState({
        [name]:
          this.state.itsOkLeader ||
          this.state.itsOkDivision ||
          this.state.itsOkSegment
            ? slice(
                orderBy(
                  uniqBy(this.props.leaders, "employee_parent_name"),
                  "employee_parent_name"
                ),
                0,
                100
              )
            : slice(
                orderBy(
                  uniqBy(this.props.leaders, "employee_parent_name"),
                  "employee_parent_name"
                ),
                0,
                100
              ),
      })
    }
    if (name === "divisions") {
      return this.setState({
        [name]:
          this.state.itsOkLeader ||
          this.state.itsOkDivision ||
          this.state.itsOkSegment
            ?  orderBy(
              this.props.divisions
            )
            :  orderBy(
              this.props.divisions
            ),
      })
    }
    if (name === "segments") {
      return this.setState({
        [name]:
          this.state.itsOkLeader ||
          this.state.itsOkDivision ||
          this.state.itsOkSegment
            ?   this.props.segments
            :   this.props.segments,
      })
    }
  }

  filterBetweenFilters = (name) => {
    
  }

  /* <-- */
  filterLoadMoreLeader = () => {
    if (!this.state.hasMoreLeaders) return

    this.setState(
      {
        leaders: [
          ...this.state.leaders,
          ...slice(
            orderBy(
              uniqBy(this.props.leaders, "employee_parent_name"),
              "employee_parent_name"
            ),
            this.state.leaders.length,
            this.state.leaders.length + 20
          ),
        ],
      },
      () => {
        if (
          uniqBy(this.props.leaders, "employee_parent_name").length <=
          this.state.leaders.length
        ) {
          this.setState({ hasMoreLeaders: false })
        }
      }
    )
  }
 

  filterForLeaderRestart = () => {
    this.setState(
      {
        leadersSelected: [],
        hasMoreLeaders: !this.state.divisionsSelected.length,
        inputSearchLeader: "",
        itsOkLeader: false,
      },
      () => {
        this.filterBetweenFilters("divisions")
        if (!this.state.divisionsSelected.length) {
          return this.setState({
            leaders: slice(
              orderBy(
                uniqBy(this.props.leaders, "employee_parent_name"),
                "employee_parent_name"
              ),
              0,
              100
            ),
          })
        }
        this.filterBetweenFilters("leaders")
        setTimeout(() => this.updateTagFilters(), 0)
      }
    )
    this.reloadFiltersRestart('leaders')

  }

  filterForLeaderOk = () => {
    if (!this.state.leadersSelected.length) return this.filterForLeaderRestart()
    this.reloadFilters()
    setItem(
      KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER,
      JSON.stringify(this.state.leadersSelected)
    )
    this.setSafeTimeout(() => this.updateTagFilters(), 0)
  }
  /* --> */

  /* <-- */
  
  filterForDivisionRestart = () => {
    this.setState(
      {
        divisionsSelected: [],
        hasMoreLeaders: !this.state.leadersSelected.length,
        inputSearchDivision: "",
        itsOkDivision: false,
      },
      () => {
        setItem(
          KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
          JSON.stringify(this.state.divisionsSelected)
        )
        this.filterBetweenFilters("divisions")
        if (!this.state.leadersSelected.length) {
          this.setState({
            leaders: slice(
              orderBy(
                uniqBy(this.props.leaders, "employee_parent_name"),
                "employee_parent_name"
              ),
              0,
              100
            ),
          })
        }
        this.setSafeTimeout(() => this.updateTagFilters(), 0)
      }
    )
    this.reloadFiltersRestart('divisions')
  
  }
  filterForDivisionOk = () => {
    if (!this.state.divisionsSelected.length)
      return this.filterForDivisionRestart()
    this.reloadFilters()
    setItem(
      KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
      JSON.stringify(this.state.divisionsSelected)
    )
    this.setSafeTimeout(() => this.updateTagFilters(), 0)

  }
  /* --> */

  /* <-- */
  filterForSegmentsRestart = () => {

    this.setState(
      {
        segmentsSelected: [],
        hasMoreLeaders: !this.state.leadersSelected.length,
        inputSearchSegment: "",
        itsOkSegment: false,
      },
      () => {
        setItem(
          KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER,
          JSON.stringify(this.state.segmentsSelected)
        )
        this.filterBetweenFilters("segments")
        if (!this.state.leadersSelected.length) {
          this.setState({
            leaders: slice(
              orderBy(
                uniqBy(this.props.leaders, "employee_parent_name"),
                "employee_parent_name"
              ),
              0,
              100
            ),
          })
        }
        this.setSafeTimeout(() => this.updateTagFilters(), 0)
      }
    )
    this.reloadFiltersRestart('segments')

  }

  filterForSegmentsOk = () => {
    if (!this.state.segmentsSelected.length)
      return this.filterForSegmentsRestart()

    this.reloadFilters()

    setItem(
      KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER,
      JSON.stringify(this.state.segmentsSelected)
    )
    this.setSafeTimeout(() => this.updateTagFilters(), 0)
  }
  /* --> */

  filterFor = (name, value) => {
    if (name === "leaders") {
      if (!value) {
        this.setState({ inputSearchLeader: value })
        return this.filterForLeaderRestart()
      }

      return this.setState({
        [name]: filter(
          uniqBy(
            orderBy(this.props.leaders, "employee_parent_name"),
            "employee_parent_name"
          ),
          (item) =>
            item.employee_parent_name
              .toLowerCase()
              .includes(value.toLowerCase())
        ),
        hasMoreLeaders: false,
        inputSearchLeader: value,
      })
    }

    if (name === "divisions") {
      return this.setState({
        [name]: filter(this.props.divisions, (item) =>
          item.division_name.toLowerCase().includes(value.toLowerCase())
        ),
        inputSearchDivision: value,
      })
    }

    if (name === "segments") {
      return this.setState({
        [name]: filter(this.props.segments, (item) =>
          item.some((element) =>
            element.name_segment.toLowerCase().includes(value.toLowerCase())
          )
        ),
        inputSearchSegment: value,
      })
    }

    this.setState({
      [name]: value,
      hasMoreLeaders:
        !this.state.divisionsSelected.length &&
        !this.state.leadersSelected.length &&
        !this.state.segmentsSelected.length,
    })
  }

  openModalOf = (name, value, collaborator = undefined) => {
    if (name === "modalDeleteCollaborators") {
      this.props.getMeasures(collaborator)
      return this.setState({ collaboratorsSelected: collaborator })
    }

    if (collaborator) {
      this.setState({ collaboratorSelected: collaborator })
    }

    if (name === "modalSelectLeader" && collaborator) {
      this.props.getPotentialLeaders(collaborator.id_employee)
    }

    this.setState({ [name]: value })
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  showTotal = (total, range) => (
    <span style={{ color: "#A6A6A6" }}>{`Total colaboradores: ${total}`}</span>
  )

  toggleSegmentsModal = (segments, collabName) => {
    this.setState({
      segmentsForModal: segments,
      collaboratorNameForModal: collabName,
      showSegmentsModal: true,
    })
  }
  reloadFilters = () => {
    const currentFilters = {
      leaders: this.state.leadersSelected,
      divisions: this.state.divisionsSelected,
      segments: this.state.segmentsSelected,
    }

    if (this.props.onActiveFiltersChange) {
      this.props.onActiveFiltersChange(currentFilters)
    }

    if (currentFilters.leaders.length > 0 || currentFilters.divisions.length > 0 || currentFilters.segments.length > 0) {
      let data = {
        ...this.state.paginationRecord,
        ...currentFilters,
        searchText: this.props.inputSearch || '',
      }
      this.props.searchCollaboratorPaginated(data)
    }
  }

  reloadFiltersRestart = (name) => {
    if (this.props.onActiveFiltersChange) {
      this.props.onActiveFiltersChange({ divisions: [], segments: [], leaders: [] })
    }

    if (this.state.leadersSelected.length > 0 || this.state.divisionsSelected.length > 0 || this.state.segmentsSelected.length > 0) {
      let data = {
        ...this.state.paginationRecord,
        leaders: name ? [] : this.state.leadersSelected,
        divisions: name ? [] : this.state.divisionsSelected,
        segments: name ? [] : this.state.segmentsSelected,
        searchText: this.props.inputSearch || '',
      }
      this.props.searchCollaboratorPaginated(data)
    }
  }

  removeFilter = (itemRemoved) => {
    return new Promise((resolve) => {
      if (itemRemoved === "delete-all") {
        return this.setState(
          {
            leadersSelected: [],
            divisionsSelected: [],
            segmentsSelected: [],
            tagFilters: [],
            itsOkLeader: false,
            itsOkDivision: false,
            itsOkSegment: false,
            inputSearchLeader: "",
            inputSearchDivision: "",
            inputSearchSegment: "",
          },
          () => {
            setItem(
              KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER,
              JSON.stringify([])
            )
            setItem(
              KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
              JSON.stringify([])
            )
            setItem(
              KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER,
              JSON.stringify([])
            )
            if (this.props.onActiveFiltersChange) {
              this.props.onActiveFiltersChange({ leaders: [], divisions: [], segments: [] })
            }
            // Reload data without filters
            const data = {
              ...this.state.paginationRecord,
              leaders: [],
              divisions: [],
              segments: []
            }
            this.props.searchCollaboratorPaginated(data)
            // Update tag filters in parent
            setTimeout(() => this.updateTagFilters(), 0)
            resolve()
          }
        )
      }

      // Remove from leaders
      const leaderNames = this.state.leaders
        .filter(leader => this.state.leadersSelected.includes(leader.id_employee_parent))
        .map(leader => leader.employee_parent_name)
      
      if (leaderNames.includes(itemRemoved)) {
        const leaderToRemove = this.state.leaders.find(leader => leader.employee_parent_name === itemRemoved)
        if (leaderToRemove) {
          const newLeadersSelected = this.state.leadersSelected.filter(
            id => id !== leaderToRemove.id_employee_parent
          )
          return this.setState(
            {
              leadersSelected: newLeadersSelected,
              tagFilters: this.state.tagFilters.filter(filter => filter !== itemRemoved),
            },
            () => {
              setItem(
                KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER,
                JSON.stringify(newLeadersSelected)
              )
              if (this.props.onActiveFiltersChange) {
                this.props.onActiveFiltersChange({
                  leaders: newLeadersSelected,
                  divisions: this.state.divisionsSelected,
                  segments: this.state.segmentsSelected,
                })
              }
              // Reload data with updated filters
              const data = {
                ...this.state.paginationRecord,
                leaders: newLeadersSelected,
                divisions: this.state.divisionsSelected,
                segments: this.state.segmentsSelected
              }
              this.props.searchCollaboratorPaginated(data)
              setTimeout(() => this.updateTagFilters(), 0)
              resolve()
            }
          )
        }
      }

      // Remove from divisions
      const divisionNames = this.state.divisions
        .filter(division => this.state.divisionsSelected.includes(division.id_division))
        .map(division => division.division_name)
      
      if (divisionNames.includes(itemRemoved)) {
        const divisionToRemove = this.state.divisions.find(division => division.division_name === itemRemoved)
        if (divisionToRemove) {
          const newDivisionsSelected = this.state.divisionsSelected.filter(
            id => id !== divisionToRemove.id_division
          )
          return this.setState(
            {
              divisionsSelected: newDivisionsSelected,
              tagFilters: this.state.tagFilters.filter(filter => filter !== itemRemoved),
            },
            () => {
              setItem(
                KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
                JSON.stringify(newDivisionsSelected)
              )
              if (this.props.onActiveFiltersChange) {
                this.props.onActiveFiltersChange({
                  leaders: this.state.leadersSelected,
                  divisions: newDivisionsSelected,
                  segments: this.state.segmentsSelected,
                })
              }
              // Reload data with updated filters
              const data = {
                ...this.state.paginationRecord,
                leaders: this.state.leadersSelected,
                divisions: newDivisionsSelected,
                segments: this.state.segmentsSelected
              }
              this.props.searchCollaboratorPaginated(data)
              setTimeout(() => this.updateTagFilters(), 0)
              resolve()
            }
          )
        }
      }

      // Remove from segments
      const segmentNames = this.state.segments
        .filter(segment => this.state.segmentsSelected.includes(segment.id_segment))
        .map(segment => segment.name_segment)
      
      if (segmentNames.includes(itemRemoved)) {
        const segmentToRemove = this.state.segments.find(segment => segment.name_segment === itemRemoved)
        if (segmentToRemove) {
          const newSegmentsSelected = this.state.segmentsSelected.filter(
            id => id !== segmentToRemove.id_segment
          )
          return this.setState(
            {
              segmentsSelected: newSegmentsSelected,
              tagFilters: this.state.tagFilters.filter(filter => filter !== itemRemoved),
            },
            () => {
              setItem(
                KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER,
                JSON.stringify(newSegmentsSelected)
              )
              if (this.props.onActiveFiltersChange) {
                this.props.onActiveFiltersChange({
                  leaders: this.state.leadersSelected,
                  divisions: this.state.divisionsSelected,
                  segments: newSegmentsSelected,
                })
              }
              // Reload data with updated filters
              const data = {
                ...this.state.paginationRecord,
                leaders: this.state.leadersSelected,
                divisions: this.state.divisionsSelected,
                segments: newSegmentsSelected
              }
              this.props.searchCollaboratorPaginated(data)
              setTimeout(() => this.updateTagFilters(), 0)
              resolve()
            }
          )
        }
      }

      resolve()
    })
  }

  updateTagFilters = () => {
    const leaderNames = this.state.leaders
      .filter(leader => this.state.leadersSelected.includes(leader.id_employee_parent))
      .map(leader => leader.employee_parent_name)
    
    const divisionNames = this.state.divisions
      .filter(division => this.state.divisionsSelected.includes(division.id_division))
      .map(division => division.division_name)
    
    // Handle segments - use props.segments if state.segments is empty or incomplete
    const segmentsSource = this.state.segments && this.state.segments.length > 0 
      ? this.state.segments 
      : this.props.segments || []
    
    const segmentNames = segmentsSource
      .filter(segment => segment && this.state.segmentsSelected.includes(segment.id_segment))
      .map(segment => segment.name_segment)

    const allFilters = [...leaderNames, ...divisionNames, ...segmentNames]
    this.setState({ tagFilters: allFilters })
    
    // Pass the filters to parent component if callback is provided
    if (this.props.onFiltersChange) {
      this.props.onFiltersChange(allFilters, this.removeFilter)
    }
  }

  render() {
    const rowSelection = {
      // columnWidth: "5%",
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ collaboratorsSelected: selectedRowKeys })
        if (selectedRows.length) {
          let payload = ""
          payload = `batch?${map(selectedRowKeys, (item, index) => {
            return `id_employee[${index}]=${item}`
          }).join("&")}`

          this.props.getMeasures(payload)
          this.props.toggleModal("buttonDeleteCollaborators", true)
        } else {
          this.props.toggleModal("buttonDeleteCollaborators", false)
        }
      },
      selectedRowKeys: this.state.collaboratorsSelected,
    }

    if (this.props.filtersDeleted) {
      if (this.props.filtersDeleted === "delete-all") {
        this.setState(
          {
            leadersSelected: [],
            divisionsSelected: [],
            segmentsSelected: [],
          },
          () => {
            setItem(
              KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
              JSON.stringify(this.state.divisionsSelected)
            )
            setItem(
              KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER,
              JSON.stringify(this.state.leadersSelected)
            )
            setItem(
              KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER,
              JSON.stringify(this.state.segmentsSelected)
            )
            this.filterForLeaderOk()
            this.filterForDivisionOk()
            this.filterForSegmentsOk()
          }
        )

        this.props.setStateFromCollaborators("filtersDeleted", undefined)
      }

      if (this.props.filtersDeleted !== "delete-all") {
        if (typeof this.props.filtersDeleted === "string") {
          this.setState(
            {
              divisionsSelected: filter(
                this.state.divisionsSelected,
                (item) => item !== this.props.filtersDeleted
              ),
            },
            () => {
              setItem(
                KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
                JSON.stringify(this.state.divisionsSelected)
              )
              this.filterForLeaderOk()
            }
          )
        } else {
          this.setState(
            {
              leadersSelected: filter(
                this.state.leadersSelected,
                (item) => item !== this.props.filtersDeleted
              ),
            },
            () => {
              setItem(
                KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER,
                JSON.stringify(this.state.leadersSelected)
              )
              this.filterForDivisionOk()
            }
          )
        }
        this.props.setStateFromCollaborators("filtersDeleted", undefined)
      }
    }
    let hasScrollTable = { x: 0 }
    if (this.props.columnsSelected.length >= 6) {
      hasScrollTable = { x: 2200 }
    }
    if (this.props.columnsSelected.length > 7) {
      hasScrollTable = { x: 3000 }
    }
    if (this.props.columnsSelected.length > 8) {
      hasScrollTable = { x: 3500 }
    }

    
  const handleTableChange = (pagination, filters, sorter) => {
    const newSortField = (sorter && sorter.order) ? sorter.field : '';
    const newSortOrder = sorter && sorter.order === 'ascend' ? 'asc' : sorter && sorter.order === 'descend' ? 'desc' : '';

    const newPaginationRecord = {
      current: pagination.current,
      pageSize: pagination.pageSize,
      sortField: newSortField,
      sortOrder: newSortOrder,
    };
    this.setState({ paginationRecord: newPaginationRecord });

    const hasSearch = this.props.inputSearch && this.props.inputSearch.trim() !== '';
    const hasFilters =
      this.state.leadersSelected.length > 0 ||
      this.state.divisionsSelected.length > 0 ||
      this.state.segmentsSelected.length > 0;

    if (hasSearch || hasFilters) {
      this.props.searchCollaboratorPaginated({
        ...newPaginationRecord,
        leaders: this.state.leadersSelected,
        divisions: this.state.divisionsSelected,
        segments: this.state.segmentsSelected,
      });
    } else {
      this.props.getCollaboratorsPaginated(pagination.current, pagination.pageSize, newSortField, newSortOrder);
    }
  };

 


    return (
      <Fragment>
        <Table
          rowSelection={!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() ? rowSelection : null}
          onChange={handleTableChange}
          rowKey={(record) => record.id_employee}
          className="collaborators-table"
          scroll={hasScrollTable}
          loading={
            this.props.isLoadingCollaboratorsTable ||
            this.props.isLoadingTable ||
            this.state.isLoadingState
          }
          columns={columns({
            leader: {
              filterForLeaderOk: this.filterForLeaderOk,
              filterForLeaderRestart: this.filterForLeaderRestart,
              leadersSelected: this.state.leadersSelected,
              leaders: this.state.leaders,
              filterLoadMoreLeader: this.filterLoadMoreLeader,
              hasMoreLeaders: this.state.hasMoreLeaders,
              inputSearchLeader: this.state.inputSearchLeader,
              dropdownOpen: this.state.leaderDropdownOpen,
              onVisibleChange: (visible) => {
                this.setState({ leaderDropdownOpen: visible })
                if (visible) this.addItemsUpdateToDropdown("leaders")
              },
              closeDropdown: () => this.setState({ leaderDropdownOpen: false }),
            },
            division: {
              divisions: this.state.divisions,
              filterForDivisionOk: this.filterForDivisionOk,
              filterForDivisionRestart: this.filterForDivisionRestart,
              divisionsSelected: this.state.divisionsSelected,
              inputSearchDivision: this.state.inputSearchDivision,
              dropdownOpen: this.state.divisionDropdownOpen,
              onVisibleChange: (visible) => {
                this.setState({ divisionDropdownOpen: visible })
                if (visible) this.addItemsUpdateToDropdown("divisions")
              },
              closeDropdown: () => this.setState({ divisionDropdownOpen: false }),
            },
            segment: {
              segments: this.state.segments,
              filterForSegmentsOk: this.filterForSegmentsOk,
              filterForSegmentsRestart: this.filterForSegmentsRestart,
              segmentsSelected: this.state.segmentsSelected,
              inputSearchSegment: this.state.inputSearchSegment,
              dropdownOpen: this.state.segmentDropdownOpen,
              onVisibleChange: (visible) => {
                this.setState({ segmentDropdownOpen: visible })
                if (visible) this.addItemsUpdateToDropdown("segments")
              },
              closeDropdown: () => this.setState({ segmentDropdownOpen: false }),
            },
            columnsSelected: this.props.columnsSelected,
            filterFor: this.filterFor,
            gender: this.state.gender,
            openModalOf: this.openModalOf,
            getTeam: this.props.getTeam,
            collaboratorTeam: this.props.collaboratorTeam,
            isLoadingCollaboratorTeam: this.props.isLoadingCollaboratorTeam,
            getTeamPotential: this.props.getTeamPotential,
            addItemsUpdateToDropdown: this.addItemsUpdateToDropdown,
            toggleModal: this.props.toggleModal,
            hasSegments: this.props.hasSegments,
            toggleSegmentsModal: this.toggleSegmentsModal,
            sortField: this.state.paginationRecord.sortField,
            sortOrder: this.state.paginationRecord.sortOrder,
          })}
          dataSource={
            this.state.itsOkLeader ||
            this.state.itsOkDivision ||
            this.state.itsOkSegment 
              ? this.state.stateCollaborators
              : this.props.collaborators
          }
          pagination={{
            pageSizeOptions: ["15", "25", "50", "100"],
            showSizeChanger: true,
            size: "default",
            defaultPageSize: 15,
            showTotal: this.showTotal,
            current: this.props.paginate.current_page,
            pageSize: this.props.paginate.per_page,
            total: this.props.paginate.total,
            sorter: {}
          }}
        />
        <ModalCustom
          modalOpen={this.props.modalDeleteCollaborators}
          textButton="Eliminar"
          colorButton="#EA6364"
          showFooter
          onCancel={() => {
            this.props.toggleModal("modalDeleteCollaborators", false)
          }}
          onOk={() => {
            let payload = ""

            if (this.state.collaboratorsSelected.length > 1) {
              let batch = `batch?${map(
                this.state.collaboratorsSelected,
                (item, index) => {
                  return `id_employee[${index}]=${item}`
                }
              ).join("&")}`
              let search_data = {
                ...this.state.paginationRecord,
                leaders: this.state.leadersSelected,
                divisions: this.state.divisionsSelected,
                segments: this.state.segmentsSelected
              }
              payload = {
                id_employee: batch,
                search_data: search_data
              }

              this.props.removeCollaboratorsWatcher(payload)
            } else {
              let search_data= {
                ...this.state.paginationRecord,
                leaders: this.state.leadersSelected,
                divisions: this.state.divisionsSelected,
                segments: this.state.segmentsSelected
              }
              payload = {
              id_employee: this.state.collaboratorsSelected[0],
              search_data: search_data
              }
              this.props.removeCollaboratorsWatcher(payload)
            }

            this.setState({ collaboratorsSelected: [] })
            this.props.toggleModal("buttonDeleteCollaborators", false)
            this.props.toggleModal("modalDeleteCollaborators", false)
            this.props.setStateFromCollaborators("inputSearch", "")
          }}
          {...pick(this.props, ["isLoadingMeasures"])}
          showFooter={!this.props.isLoadingMeasures}>
          {this.props.isLoadingMeasures && (
            <Spin
              spinning
              size="large"
              className="collaborators-delete-modal-load-spin"
            />
          )}

          {!this.props.isLoadingMeasures && (
            <img src={alertSvg} className="alertIcon" />
          )}

          {!this.props.isLoadingMeasures && (
            <span>
              <span style={{ fontSize: 14, fontWeight: 600 }}>
                ¿Estás seguro de que deseas eliminar{" "}
                {this.state.collaboratorsSelected.length > 1
                  ? "a los colaboradores"
                  : "al colaborador"}
                ?
              </span>
              {this.props.measuresAffected.length > 0 && (
                <p style={{ fontSize: 13, marginTop: 8 }}>
                  Se <b>eliminarán</b> tambien sus respuestas en las mediciones
                  que
                  <br />{" "}
                  {this.state.collaboratorsSelected.length > 1
                    ? "participaron"
                    : "participó"}
                  , que aún no han sido oficializadas:
                  <br />
                  <br />
                  {this.props.measuresAffected.map((measure, index) => {
                    return (
                      <span key={index}>
                        {measure.name}
                        <br />
                      </span>
                    )
                  })}
                </p>
              )}
              <p style={{ fontSize: 13, marginTop: 8 }}>
                La acción <b>no será reversible</b>
                {this.props.measuresAffected.length > 0
                  ? "."
                  : ", y se perderá su historial en el sistema. De ser el caso, deberás asignarle un nuevo líder a su equipo."}
              </p>
            </span>
          )}
        </ModalCustom>
        {this.state.modalTeam && (
          <TeamModal
            collaboratorSelected={this.state.collaboratorSelected}
            modalOpen={this.state.modalTeam}
            openModalOf={this.openModalOf}
            paginationRecord={this.state.paginationRecord}
            leaders={this.state.leaders}
            divisions={this.state.divisions}
            segments={this.state.segments}
            {...pick(this.props, [
              "setStateFromCollaborators",
              "removeEmployeesTeamWatcher",
              "handleInputChange",
              "addEmployeesTeamWatcher",
              "teamPotential",
              "isLoadingTeamPotential",
              "isLoadingCollaboratorTeam",
              "collaboratorTeam",
            ])}
          />
        )}
        <ModalSelectLeader
          setStateFrom={this.setStateFrom}
          visible={this.state.modalSelectLeader}
          collaboratorSelected={this.state.collaboratorSelected}
          paginationRecord={this.state.paginationRecord}
          leaders={this.state.leaders}
          divisions={this.state.divisions}
          segments={this.state.segments}
          {...pick(this.props, [
            "setStateFromCollaborators",
            "assignLeader",
            "isLoadingPotentialLeaders",
            "potentialLeaders",
          ])}
        />
        <SegmentsModal
          segments={this.state.segmentsForModal}
          collaboratorName={this.state.collaboratorNameForModal}
          show={this.state.showSegmentsModal}
          onOk={() => {
            this.setState({ showSegmentsModal: false })
          }}
        />
      </Fragment>
    )
  }
}

CollaboratorsTable.propTypes = {}

export default CollaboratorsTable
